module.exports = __webpack_public_path__ + "static/media/ALC_GKB_Web_-1.e44bc87f.JPG";